



















import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
import ThreePanelConditionChip from './three-panel-condition-chip.vue';
@Component({
  components: {
    ThreePanelConditionChip
  }
})
export default class ThreePanelConditionChips extends Vue {
  @Prop()
  selectedAggregated: any[];

  @Emit('remove')
  onRemove(name: string, brand: string) { }
}
